module.exports = __webpack_public_path__ + "img/NewsCenter_pic3.ab874ada.png";